import request from '@/utils/request'

// 查询行政区划列表
export function listDistrict(query) {
  return request({
    url: '/system/district/list',
    method: 'get',
    params: query
  })
}

// 查询行政区划详细
export function getDistrict(id) {
  return request({
    url: '/system/district/' + id,
    method: 'get'
  })
}

// 同步刷新行政区划
export function refresh() {
  return request({
    url: '/system/district/refresh',
    method: 'POST'
  })
}

// 新增行政区划
export function addDistrict(data) {
  return request({
    url: '/system/district',
    method: 'post',
    data: data
  })
}

// 修改行政区划
export function updateDistrict(data) {
  return request({
    url: '/system/district',
    method: 'put',
    data: data
  })
}

// 删除行政区划
export function delDistrict(id) {
  return request({
    url: '/system/district/' + id,
    method: 'delete'
  })
}

// 导出行政区划
export function exportDistrict(query) {
  return request({
    url: '/system/district/export',
    method: 'get',
    params: query
  })
}


// 查询行政区划
export function optionSelect() {
  return request({
    url: '/system/district/optionSelect',
    method: 'get'
  })
}

// 地址解析(地址转坐标)
export function geoCoder(address) {
  return request({
    url: '/system/district/geoCoder?address=' + address,
    method: 'get'
  })
}
